export const DEFAULT_SCORE_COLOR_CLASS = 'sh-color-gray-3';

export function normalizeOpportunityValue(value) {
    return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/ /g, '_');
}

export function humanizeScoreText(value) {
    if (!value) {
        return '';
    }

    return String(value)
        .replace(/[_/\\-]+/g, ' ')
        .split(' ')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export function getOpportunityColorClass(value) {
    const normalizedValue = normalizeOpportunityValue(value);

    if (normalizedValue === 'strong_avoid') {
        return 'text-red-dark';
    }

    if (normalizedValue === 'avoid') {
        return 'text-danger';
    }

    if (normalizedValue === 'strong_buy') {
        return 'text-green-dark';
    }

    if (normalizedValue === 'buy') {
        return 'text-success';
    }

    if (normalizedValue === 'consider') {
        return 'text-warning';
    }

    return DEFAULT_SCORE_COLOR_CLASS;
}
